import React from 'react'
import Modal from 'react-modal'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

import BkFlowConfirmationPreCheckIn from './BkFlowConfirmationPreCheckIn'
import BkFlowMaterialLoader from '../../../elements/BkFlowMaterialLoader'

const BkFlowPreCheckinModal = props => {
  const {
    closePreCheckInModal,
    handlePreCheckinPanel,
    hotelLabels,
    isPreCheckDisabled,
    preCheckGroupExpanded,
    preCheckinModalVisible,
    modifyPreCheckin,
    reservations,
    reservationError,
    reservationLoading
  } = props

  // Override MUI expansion styles
  const preCheckInTheme = createMuiTheme({
    overrides: {
      MuiExpansionPanel: {
        root: {
          background: '#e4e4e4',
          margin: '0 0 10px 0',
        },
      },
      MuiPaper: {
        elevation1: {
          boxShadow: 'none',
        },
      },
    },
  })

  const renderPreCheckinExpansions = () => {
    if (reservations) {
      let reservation = reservations

      if (reservation) {
        return Object.keys(reservation).map(reservationKey => {
          const roomType = reservation[reservationKey].roomStays[0].roomTypes[0].roomDescription.name

          return (
            <ExpansionPanel
              className="bk-flow-confirmation__pre-check-group"
              key={ reservationKey }
              expanded={ preCheckGroupExpanded === reservationKey }
              onChange={ () => handlePreCheckinPanel(reservationKey) }
            >
              <ExpansionPanelSummary className="u-font-medium u-font-bold">
                { hotelLabels.room ? hotelLabels.room : 'Room' } { Number(reservationKey) + 1 } - { roomType }
                { preCheckGroupExpanded === reservationKey ?
                  <i className="material-icons">arrow_drop_up</i>
                :
                  <i className="material-icons">arrow_drop_down</i>
                }
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <BkFlowConfirmationPreCheckIn
                  reservationKey={ reservationKey }
                />
              </ExpansionPanelDetails>
            </ExpansionPanel>
          )
        })
      }
    }
  }

  return (
    <Modal
      className={{
        base: 'u-modal u-modal--xxs',
        afterOpen: 'u-modal--visible',
        beforeClose: 'u-modal--close',
        ariaHideApp: false
      }}
      overlayClassName={{
        base: 'u-fade',
        afterOpen: 'u-fade--visible',
        beforeClose: 'u-fade--visible'
      }}
      isOpen={ preCheckinModalVisible }
      onRequestClose={ closePreCheckInModal }
      contentLabel="Edit Reservation Modal"
      shouldCloseOnOverlayClick={ true }
      ariaHideApp={ false }
    >
      <div className="bk-flow-confirmation__pre-check">
        <div className="u-modal__header">
          <h5>{ hotelLabels.preCheckIn ? hotelLabels.preCheckIn : 'Pre Check-in' }</h5>
          <div
            className="u-modal__close u-font-small u-font-bold"
            onClick={ () => closePreCheckInModal() }
          >
            { hotelLabels.close ? hotelLabels.close : 'Close'}
            <i className="material-icons">close</i>
          </div>

        </div>
        <div className="u-modal__body">
          <MuiThemeProvider theme={ preCheckInTheme }>
            <p>{ hotelLabels.preCheckInMessage ? hotelLabels.preCheckInMessage : 'Keep it simple, select pre check-in below so you can head straight to your room as soon as it’s ready for you'}:</p>
            { renderPreCheckinExpansions() }
          </MuiThemeProvider>

          { reservationError &&
            <div className="bk-flow-room__errors">
              <h5 className="u-remove-margin">{ hotelLabels.modifyPreCheckInError ? hotelLabels.modifyPreCheckInError : 'Error modifying reservation - please wait a moment and try again'}</h5>
              <p className="u-remove-margin">{ reservationError.message }</p>
            </div>
          }

          { reservationLoading ?
            <BkFlowMaterialLoader loaderClasses="bk-flow-confirmation__pre-check__loading" />
          :
            <button
              disabled={ isPreCheckDisabled }
              className="btn btn-primary"
              onClick={ () => modifyPreCheckin() }
            >
              { hotelLabels.submit ? hotelLabels.submit : 'Submit' }
            </button>
          }

          { reservations &&
            reservations[0] &&
            reservations[0].viewExtensions &&
            reservations[0].viewExtensions.status === 'Modified' &&
            <div className="bk-flow-confirmation__pre-check-success">
              <h5 className="u-remove-margin">{hotelLabels.success ? hotelLabels.success : 'Success!' }</h5>
              <p>{ hotelLabels.modifyPreCheckInSuccess ? hotelLabels.modifyPreCheckInSuccess : 'Reservation pre check-in successful'}.</p>
              <button
                className="btn btn-primary"
                onClick={ () => closePreCheckInModal() }
              >
                { hotelLabels.viewConfirmation ? hotelLabels.viewConfirmation : 'View Confirmation' }
              </button>
            </div>
          }
        </div>
      </div>
    </Modal>
  )
}

export default BkFlowPreCheckinModal



// WEBPACK FOOTER //
// ./src/components/confirmation/elements/default/BkFlowPreCheckInModal.js